document.body.addEventListener("click", function (event) {
    if (event.target.classList.contains("collapsible-button") && event.target.closest('.js-collapsible-wrapper') || event.target.closest(".collapsible-button") && event.target.closest('.js-collapsible-wrapper')) {
        if (event.target.closest('.collapsible-block')) {
            if (event.target.closest('.collapsible-block').classList.contains('open')) {
                event.target.closest('.collapsible-block').classList.remove('open');
                if (event.target.closest('.collapsible-block').querySelector('.collapsible-content')) {
                    event.target.closest('.collapsible-block').querySelector('.collapsible-content').style.height = 0;
                }
            } else {
                event.target.closest('.collapsible-block').classList.add('open');
                if (event.target.closest('.collapsible-block').querySelector('.collapsible-content')) {
                    event.target.closest('.collapsible-block').querySelector('.collapsible-content').style.height = event.target.closest('.collapsible-block').querySelector('.collapsible-content').scrollHeight + 'px';
                }
            }
        }
    }
});

$( document ).ready(function() {
    if ($('.js-membership-reviews-list').length > 0) {
        $('.js-membership-reviews-list').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="icon"><svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"></path></svg></span></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="icon"><svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"></path></svg></span></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true,
                    }
                },
            ]
        });
    }
    if ($('.js-membership-team-slider').length > 0) {
        $('.js-membership-team-slider').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="icon"><svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"></path></svg></span></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="icon"><svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"></path></svg></span></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        });
    }
    if ($('.js-membership-advantages-slider').length > 0) {
        $('.js-membership-advantages-slider').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="icon"><svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"></path></svg></span></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="icon"><svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z"></path></svg></span></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        });
    }
});